module.exports = __webpack_public_path__ + "static/media/DP_Jacquard_Accademia_DK Chocolate_LT Grey.7f327be1.png";